import(/* webpackMode: "eager" */ "/vercel/path0/app/articles/[slug]/error.tsx");
